export default __webpack_public_path__ + "static/media/logo-devcolibri-23.e0e1fc78.webp";